import { Injectable } from '@angular/core';
import { MilkingModel } from '../schemes/models/milking.model';
import { ResponseModel } from '../schemes/models/response.model';
import { HttpService } from '../services/http.service';
import { BaseProvider } from './base.provider';

@Injectable({
	providedIn: 'root',
})
export class MilkingProvider extends BaseProvider<MilkingModel> {
	constructor(http: HttpService) {
		super('milkings', http);
	}

	importDryDates(milkingsToDry: any[]): Promise<ResponseModel<MilkingModel[]>> {
		const milkingDry = milkingsToDry.map(milking => ({
			_id: milking._id,
			dryDate: milking.dryDate,
			milkingAmount24: milking.milkingAmount24,
			incidences: milking.incidences,
			fat: milking.fat,
			protein: milking.protein,
			dryExtract: milking.dryExtract,
			originalMilkingAmount24: milking.originalMilkingAmount24,
			originalFat: milking.originalFat,
			originalProtein: milking.originalProtein,
			originalDryExtract: milking.originalDryExtract,
		}));
		return this.http.patch<ResponseModel<MilkingModel[]>>(
			`${this.collection}/many/`,
			{ data: milkingDry },
			{
				database: this.database || HttpService.currentDb,
			}
		);
	}

	changeDryDates(milkingIds, dryDate) {
		const dryDatesChange = milkingIds.map(milkingId => ({
			_id: milkingId,
			dryDate,
		}));

		return this.http.patch<ResponseModel<MilkingModel[]>>(
			`${this.collection}/many/`,
			{ data: dryDatesChange },
			{
				database: this.database || HttpService.currentDb,
			}
		);
	}
}
